import React, { ReactElement } from 'react';

export const detailLabelClass = 'text-xs font-semibold uppercase tracking-wider text-muted-foreground';

/** One aligned label/value row in a details list. Shared so the detail pages cannot drift apart. */
export const DetailRow = ({ label, children }: { label: string; children: React.ReactNode }): ReactElement => (
  <div className="flex flex-col gap-1 py-4 first:pt-0 last:pb-0 sm:flex-row sm:gap-6">
    <dt className={`${detailLabelClass} sm:w-44 sm:shrink-0 sm:pt-1.5`}>{label}</dt>
    <dd className="min-w-0 flex-1 text-sm text-foreground">{children}</dd>
  </div>
);
